import CCBGenEmprestimo from './ccbgenemprestimo.component'
import CCBGenFGTS from './ccbgenfgts.component';
import { IDocument } from '../../ts/interfaces/Components.interfaces'
import { getStateJornada } from '../../state/actions/jornada_actions';
import CCBGenRefin from './ccbgenrefin.component';
import CCBGenEmprestimoArbi from './ccbgenemprestimoArbi.component';

const CCBGen = ({Status} : IDocument) => {
  const {tipo, contrato} = getStateJornada();
  const tipoProposta = contrato.Proposta.TipoProposta
  const empregador = contrato.Proposta.CodigoEmpregador
  if(tipo == 5){
    return <CCBGenFGTS Status={Status} />
  }else if(tipoProposta == 7){
    return <CCBGenRefin Status={Status}/>
  }else{
    if (empregador == 132|| empregador == 136|| empregador == 137 || empregador == 138 || empregador == 143 || empregador == 140 || empregador == 150 || empregador == 149 || empregador == 135 || empregador == 131 || empregador == 155 || empregador == 154 || empregador == 157) {
      return <CCBGenEmprestimoArbi Status={Status}/>
    }else{
      return <CCBGenEmprestimo Status={Status}/>
    }
  }
}

export default CCBGen